import { useEffect, useState } from 'react';

const useRole = () => {
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.roles && payload.roles.length > 0) {
          setRole(payload.roles[0]); // Take the first role
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        setRole(null);
      }
    } else {
      setRole(null);
    }
  }, []);

  return role;
};

// Helper function to check if current user is admin
export const useIsAdmin = () => {
  const role = useRole();
  return role === 'ROLE_ADMIN';
};

export default useRole;
